import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LoaderService {
  isInProgress = new Subject<boolean>();

  show() {
    this.isInProgress.next(true);
  }

  hide() {
    this.isInProgress.next(false);
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/loader.service.ts